import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/blog/newblog.css");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/images/blog.png");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/link.js");
